import { Component } from 'react';
import PropTypes from 'prop-types';
import DOM from 'react-dom-factories';

export default class DateTimePickerYears extends Component {
  static propTypes = {
    renderYear: PropTypes.func,
    setDate: PropTypes.func,
    handleClickOutside: PropTypes.func,
    subtractTime: PropTypes.func,
    addTime: PropTypes.func,
    showView: PropTypes.func,
    updateSelectedDate: PropTypes.func,
    viewDate: PropTypes.oneOfType([ PropTypes.string, PropTypes.object ]),
    selectedDate: PropTypes.oneOfType([ PropTypes.string, PropTypes.object ]),
    updateOn: PropTypes.string,
    isValidDate: PropTypes.bool,
    prevIcon: PropTypes.oneOfType([ PropTypes.string, PropTypes.object ]),
    nextIcon: PropTypes.oneOfType([ PropTypes.string, PropTypes.object ]),
  };

  renderYears (year) {
    let years = [];
    let i = -1;
    let rows = [];
    let renderer = this.props.renderYear || this.renderYear;
    let selectedDate = this.props.selectedDate;
    let isValid = this.props.isValidDate || this.alwaysValidDate;
    let classes, props, currentYear, isDisabled, noOfDaysInYear, daysInYear, validDay;
    // Month and date are irrelevant here because
    // we're only interested in the year
    let irrelevantMonth = 0;
    let irrelevantDate = 1;

    year--;
    while (i < 11) {
      classes = 'date-time-picker-year';
      currentYear = this.props.viewDate
        .clone()
        .set({ year: year, month: irrelevantMonth, date: irrelevantDate });

      // Not sure what 'date-time-picker-old' is for, commenting out for now as it's not working properly
      // if ( i === -1 | i === 10 )
      // classes += ' date-time-picker-old';

      noOfDaysInYear = currentYear.endOf('year').format('DDD');
      daysInYear = Array.from({ length: noOfDaysInYear }, function (e, i) {
        return i + 1;
      });

      validDay = daysInYear.find(function (d) {
        let day = currentYear.clone().dayOfYear(d);
        return isValid(day);
      });

      isDisabled = validDay === undefined;

      if (isDisabled) classes += ' date-time-picker-disabled';

      if (selectedDate && selectedDate.year() === year) classes += ' date-time-picker-active';

      props = {
        key: year,
        'data-value': year,
        className: classes,
      };

      if (!isDisabled) {
        props.onClick =
          this.props.updateOn === 'years' ? this.updateSelectedYear : this.props.setDate('year');
      }

      years.push(renderer(props, year, selectedDate && selectedDate.clone()));

      if (years.length === 4) {
        rows.push(DOM.tr({ key: i }, years));
        years = [];
      }

      year++;
      i++;
    }

    return rows;
  }

  updateSelectedYear (event) {
    this.props.updateSelectedDate(event);
  }

  renderYear (props, year) {
    return DOM.td(props, year);
  }

  alwaysValidDate () {
    return 1;
  }

  handleClickOutside () {
    this.props.handleClickOutside();
  }

  render () {
    let year = parseInt(this.props.viewDate.year() / 10, 10) * 10;

    return DOM.div({ className: 'date-time-picker-years' }, [
      DOM.table(
        { key: 'a' },
        DOM.thead(
          {},
          DOM.tr({}, [
            DOM.th(
              {
                key: 'prev',
                className: 'date-time-picker-prev',
                onClick: this.props.subtractTime(10, 'years'),
              },
              DOM.span({}, this.props.prevIcon || '‹')
            ),
            DOM.th(
              {
                key: 'year',
                className: 'date-time-picker-switch',
                onClick: this.props.showView('years'),
                colSpan: 2,
              },
              year + '-' + (year + 9)
            ),
            DOM.th(
              {
                key: 'next',
                className: 'date-time-picker-next',
                onClick: this.props.addTime(10, 'years'),
              },
              DOM.span({}, this.props.nextIcon || '›')
            ),
          ])
        )
      ),
      DOM.table({ key: 'years' }, DOM.tbody({}, this.renderYears(year))),
    ]);
  }
}



// WEBPACK FOOTER //
// ./src/containers/date-time-picker/YearsView.js